var slideCollection = new Swiper('.logo_scroll', {
    slidesPerView: 1.8, 
    loop:true,
    speed:5000,
    autoplay:{
        delay : 0,
        disableOnInteraction : false,
    },
  breakpoints: { 

      769: {
       slidesPerView: 4.5, 
      },
      1024: {

       slidesPerView: 5, 
      },
      1400: {
       slidesPerView: 6, 


      },
    }

});